import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "row screen-box" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = {
  key: 0,
  class: "voided-tip-out"
}
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = { class: "voided-tip-text-out" }
const _hoisted_7 = { class: "container block" }
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { class: "flow-message-cell" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "pop-content" }
const _hoisted_17 = { class: "voided-tip" }
const _hoisted_18 = { class: "voided-tip-text" }
const _hoisted_19 = { class: "footbtn" }
const _hoisted_20 = { class: "contract-year-box" }
const _hoisted_21 = { class: "voided-tip" }
const _hoisted_22 = { class: "voided-content" }
const _hoisted_23 = { class: "input-with-counter" }
const _hoisted_24 = { class: "char-counter" }
const _hoisted_25 = { class: "footbtn" }
const _hoisted_26 = { class: "contract-year-box" }
const _hoisted_27 = { class: "row year-row" }
const _hoisted_28 = { class: "input-with-counter" }
const _hoisted_29 = { class: "char-counter" }
const _hoisted_30 = { class: "footbtn" }
const _hoisted_31 = { class: "contract-year-box" }
const _hoisted_32 = { class: "footbtn" }

import alertBox from '@/components/alert-box.vue'

import user from '@/utils/user'
import { defineComponent } from 'vue'
import {
    getContractRecord,
    ContractRecordDto,
    openContractDetail,
    rescindSignContract,
    batchRescindSignContract,
    revokeContract,
    batchRevokeContract,
    createReleaseFlow,
    createReleaseFlowBatch
} from '@/api/contract'
import axios from 'axios'
import { downLoadFile, downloadFileAndChangeName } from '../utils/util'
import { exportContractRecord, downloadSignRecordPdfForFlows } from '@/api/export'
import store from '@/store/index'
import { shortcuts } from '@/utils/global'
import { getContractVoidedFailedlist, updateNotifyReleaseFail, ContractVoidedFailedListRes } from '@/api/salary'
import tableComponent from '@/components/table-component/index.vue'
const __default__ = defineComponent({
    name: 'ContractList',
    components: {
        tableComponent
    },
    data() {
        return {
            userId: 0,
            companyId: 0,
            selectht: [] as any,
            active: '全部',
            total: 0,
            pageSize: 10,
            pageNum: 1,
            tableData: [] as ContractRecordDto[],
            payDateSolt: '',
            searchValue: '',
            searchText: '',
            selects: [] as number[],
            shortcuts: shortcuts,
            activeTab: 'alldata',
            showDetail: true,
            flowMessage: '',
            reason: '',
            showReasonPop: false,
            showFailPop: false,
            cancelType: '',
            currentCancelId: 0,
            currentCancelIds: [] as number[],
            currentFlowId: '',
            conditionQuery: '',
            voidedReason: '',
            showVoidedReasonPop: false,
            popHasId: '',
            showVoidedPop: false,
            showPeople: '',
            showVoidedOutTip: false,
            failedSelectedIds: [] as number[],// 失败弹窗的独立选择
            isBatchRelease: false,
            pageInfo: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            popupTableData: [],
            tableHead: [
                {
                    prop: 'index'
                },
                {
                    prop: 'userName',
                    label: '姓名'
                },
                {
                    prop: 'templateName',
                    label: '合同模板'
                },
                {
                    prop: 'serveCompanyName',
                    label: '签署企业'
                }
            ],
            hasUpdate: false,
        }
    },
    created() {
        user.waitLogin().then(() => {
            this.userId = Number(user.userId)
            const storeCompanyId = (store.state.bankInfo as any)?.companyId
            const fromUser = (user as any).companyId
            this.companyId = Number(storeCompanyId || fromUser || 0)
            console.log(this.userId, this.companyId, "88888889");
            this.handleCurrentChange()
            this.getData()
        })
    },
    mounted() {
    },
    methods: {
        truncateFlowMessage(text: any) {
            const s = (text ?? '').toString()
            return s.length > 15 ? s.slice(0, 15) + '...' : s
        },
        getStatusLabel(flowStatus: string) {
            const obj: { [key: string]: string } = {
                // 'INIT': '待签署',
                // 'PART': '待签署',
                // 'ALL': '已签署',
                // 'CANCEL': '已撤销',
                // 'REJECT': '已拒签',
                // 'DEADLINE': '已过期',
                // 'RELEASE': '已解除'

                '待签署': 'INIT',
                '已签署': 'ALL',
                '已撤销': 'CANCEL',
                '已拒签': 'REJECT',
                '到期未签': 'DEADLINE',
                '已解除': 'RELEASED',
                '协商解除中': 'RELEASEING'
            }
            return obj[flowStatus] || flowStatus
        },
        getStatusClass(flowStatusType: string) {
            const classes: { [key: string]: string } = {
                'INIT': 'status-tag-waiting',
                'PART': 'status-tag-waiting',
                'ALL': 'status-tag-signed',
                'CANCEL': 'status-tag-cancelled',
                'REJECT': 'status-tag-rejected',
                'DEADLINE': 'status-tag-expired',
                'RELEASED': 'status-tag-signed',
                'RELEASEING': 'status-tag-waiting'
            }
            return classes[flowStatusType] || ''
        },
        async handleCurrentChange() {
            const query: any = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                searchText: this.searchValue,
                beginCreateTime: this.payDateSolt ? this.payDateSolt[0] : '',
                endCreateTime: this.payDateSolt ? this.payDateSolt[1] : '',
            }

            if (this.activeTab !== 'alldata') {
                query.conditionQuery = this.conditionQuery
            }

            await getContractRecord(query).then(res => {
                this.total = res.total
                this.tableData = res.list.map((item: ContractRecordDto) => {
                    // if (item.isDelete === 1) {
                    return {
                        ...item,
                        flowStatusType: this.getStatusLabel(item.flowStatus),
                    }
                    // }
                    // return item
                })

                console.log(this.tableData, "处理后的数据");
            })

        },
        handleSizeChange() {
            this.pageNum = 1
            this.handleCurrentChange()
        },
        search() {
            this.searchValue = this.searchText
            this.pageNum = 1
            this.handleCurrentChange()
        },
        onReset() {
            this.searchText = ''
            this.payDateSolt = ''
            this.search()
        },
        async downloadSignRecordPdfForFlowsfn(arr: any) {
            const result = await downloadSignRecordPdfForFlows({
                ids: arr
            }, {
                loading: false
            })
            console.log(result, 'resultresultresult')
            if (result.length > 0) {
                result.forEach((item: any) => {
                    downloadFileAndChangeName(item.url, item.name + '.' + item.type)
                })
            }
        },
        async onExportht() {
            this.downloadSignRecordPdfForFlowsfn(this.selectht)
        },
        async onExporthtalong(id: any) {
            let arr = [id]
            this.downloadSignRecordPdfForFlowsfn(arr)
        },
        // 导出数据
        async onExport() {
            if (this.selects.length === 0) {
                this.$message.error('请至少选择一条数据')
                return
            }
            const result = await exportContractRecord({
                ids: this.selects.join(','),
                searchText: this.searchValue
            }, {
                loading: true
            })
            if (!result.fileUrl && result.exportStatus === 0) {
                store.commit('getLongPollingFile', result)
            } else {
                axios({
                    url: result.fileUrl,
                    method: 'GET',
                    responseType: 'blob'
                }).then(async (response) => {
                    await downLoadFile(response, result.exportType, result.updateTime, result.remark)
                    await this.$message.success('导出成功！')
                })
            }
            // window.location.href =
            //     process.env.VUE_APP_BASE_URL +
            //         '/common/download?delete=true&fileName=' +
            //         result

            // this.$message.success('导出成功！')
        },
        handleSelectionChange(selects: { id: number }[]) {
            console.log(selects, 'selects')
            this.selects = selects.map(item => item.id)
            console.log(this.selects, 'this.selects');

            this.selectht = []
            selects.forEach((ele: any, i: number) => {
                if (ele.flowType !== 20) {
                    this.selectht.push(ele.id)
                }
            })
            console.log(this.selectht, 'this.selectht')
        },
        async goDetail(flowId: string) {
            console.log(flowId, 'flowId')

            const result = await openContractDetail(flowId)
            console.log(result, 'result')
            window.open(result.consoleUrl)
        },
        // 撤销合同
        onCancelContract(rowData: ContractRecordDto) {
            this.cancelType = 'single'
            this.currentCancelId = rowData.id
            if (rowData.flowId) {
                this.currentFlowId = rowData.flowId
                this.showFailPop = true
            } else {
                this.showReasonPop = true
            }
        },
        // 批量撤销
        onBatchCancel() {
            if (this.selects.length === 0) {
                this.$message.error('请至少选择一条数据')
                return
            }
            this.cancelType = 'batch'
            this.currentCancelIds = [...this.selects]
            this.showReasonPop = true
        },
        // 删除合同
        async onDeleteContract(data: ContractRecordDto) {
            try {
                await this.$confirm('确定要删除该合同吗？删除后无法恢复！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await rescindSignContract({ id: data.id })
                this.$message.success('删除成功！')
                this.handleCurrentChange()
            } catch (error) {
                console.log('取消删除')
            }
        },
        handleTabClick(tab: { props: { name: string } }) {
            this.activeTab = tab.props.name
            this.pageNum = 1
            this.conditionQuery = this.activeTab
            console.log('条件查询参数:', this.conditionQuery)
            this.handleCurrentChange()
        },
        // 批量下载合同
        async onBatchDownload() {
            if (this.selects.length === 0) {
                this.$message.error('请至少选择一条数据')
                return
            }

            await this.onExportht()

        },
        // 批量删除
        async onBatchDelete() {
            if (this.selects.length === 0) {
                this.$message.error('请至少选择一条数据')
                return
            }
            await this.$confirm(`确定要删除选中的 ${this.selects.length} 个合同吗？删除后无法恢复！`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            await batchRescindSignContract({ ids: this.selects })
            this.$message.success('批量删除成功！')
            this.handleCurrentChange()
        },
        // 关闭撤销弹窗
        onCloseCancelPopup() {
            this.showReasonPop = false
            this.showFailPop = false
            this.cancelType = ''
            this.currentCancelId = 0
            this.currentCancelIds = []
            this.currentFlowId = ''
            this.reason = ''
        },
        // 确认撤销
        async onConfirmCancel() {
            if (!this.reason.trim()) {
                this.$message.error('请输入撤销理由')
                return
            }

            if (this.cancelType === 'single') {
                const params = {
                    id: this.currentCancelId,
                    flowMessage: this.reason
                }
                await revokeContract(params)
                this.$message.success('撤销成功！')
            } else if (this.cancelType === 'batch') {
                const batchData = {
                    ids: this.currentCancelIds,
                    flowMessage: this.reason
                }
                await batchRevokeContract(batchData)
                this.$message.success('批量撤销成功！')
            }
            this.onCloseCancelPopup()
            this.handleCurrentChange()
        },
        onShowVoidedPopup(data: string | null, fromFailedPopup: boolean) {
            this.hasUpdate = true
            this.setVoidedPopDismissed(true)
            this.isBatchRelease = !!fromFailedPopup
            console.log(this.isBatchRelease, "检查");

            if (this.isBatchRelease) {
                if (!this.failedSelectedIds || this.failedSelectedIds.length === 0) {
                    this.$message.error('请在弹窗中选择至少一条需要再次申请解除的数据')
                    return
                }
                this.showVoidedPop = false
                this.showVoidedReasonPop = true
            } else {
                if (data) {
                    this.popHasId = data
                }
                this.showVoidedReasonPop = true
            }
        },
        onCloseVoidedPopup() {
            this.showVoidedReasonPop = false
            this.popHasId = ''
            this.flowMessage = ''
            this.isBatchRelease = false
        },
        handlePopupSelectionChange(selects: { id: number }[]) {
            this.failedSelectedIds = selects.map(item => item.id)
        },
        // async handleApplyRelease() {
        //     console.log("解除协议id", this.selects);

        //     const promises = this.selects.map(id => {
        //         return createReleaseFlow({
        //             id: id,
        //             flowMessage: ''
        //         });
        //     });
        //     const results = await Promise.all(promises);
        //     console.log(results, "批量解除协议结果");
        //     // this.$message.success(`成功发起 ${idArray.length} 条解除协议申请`);
        //     return results;
        // },
        async handleUpdatePop() {
            if (!this.failedSelectedIds || this.failedSelectedIds.length === 0) {
                this.$message.error('请在弹窗中选择至少一条确认恢复“已签署”的数据')
                return
            }
            const res = await updateNotifyReleaseFail({ ids: this.failedSelectedIds })
            this.hasUpdate = true
            this.setVoidedPopDismissed(true)
            console.log(res, "知道了-弹窗状态");
            this.$message.success('已确认恢复“已签署”，数据已刷新')
            this.onCloseVoidedFailedPopup()
            await this.handleCurrentChange()
            await this.getData()
        },
        onCloseVoidedFailedPopup() {
            this.showVoidedPop = false
            this.hasUpdate = true
            this.setVoidedPopDismissed(true)
        },
        async getData() {
            // companyId 兜底处理，避免未设置导致接口拿不到
            if (!this.companyId || !Number.isFinite(this.companyId) || this.companyId <= 0) {
                const storeCompanyId = (store.state.bankInfo as any)?.companyId
                const fromUser = (user as any).companyId
                this.companyId = Number(storeCompanyId || fromUser || 0)
            }
            if (!this.companyId || !Number.isFinite(this.companyId) || this.companyId <= 0) {
                console.warn('未获取到有效的 companyId，跳过失败列表请求')
                return
            }
            const res = await getContractVoidedFailedlist({ companyId: this.companyId })
            if (res.list && res.totalCount > 0) {
                this.popupTableData = res.list
                this.pageInfo.total = res.totalCount
                this.showPeople = res.list.slice(0, 3).map(item => item.userName).join('、')
                this.showVoidedOutTip = true
                if (!this.hasVoidedPopDismissed()) {
                    this.showVoidedPopupFn()
                }
                console.log("显示弹窗", res, this.hasUpdate);
            } else {
                console.log("显示弹窗", res, this.hasUpdate);

                this.showVoidedPop = false
                this.showVoidedOutTip = false
                this.setVoidedPopDismissed(false)
            }

        },
        showVoidedPopupFn() {
            this.showVoidedPop = true
        },
        async onSendVoidedContractApply() {
            if (!this.flowMessage || this.flowMessage.trim().length === 0) {
                this.$message.error('请输入协商解除原因')
                return
            }
            if (this.isBatchRelease) {
                if (!this.failedSelectedIds || this.failedSelectedIds.length === 0) {
                    this.$message.error('未获取到需要发起协商解除的合同')
                    return
                }
                const res = await createReleaseFlowBatch({ ids: this.failedSelectedIds, flowMessage: this.flowMessage })
                console.log(res, "批量解除协议结果");
                this.$message({
                    type: 'warning',
                    message: String(res).replace(/\n/g, '<br/>'),
                    dangerouslyUseHTMLString: true
                })
            } else {
                await createReleaseFlow({ id: this.popHasId, flowMessage: this.flowMessage })
                this.$message.success('已成功发起协商解除申请')
            }
            this.onCloseVoidedPopup()
            this.handleCurrentChange()
            try {
                await this.getData()
            } catch { }
            return
        },
        getVoidedPopStorageKey() {
            const uid = Number.isFinite(this.userId) ? this.userId : 0
            const cid = Number.isFinite(this.companyId) ? this.companyId : 0
            console.log(uid, cid, "9999999");

            return `elesign:voided_failed_popup_dismissed:${uid}:${cid}`
        },
        hasVoidedPopDismissed() {
            try {
                return localStorage.getItem(this.getVoidedPopStorageKey()) === '1'
            } catch {
                return false
            }
        },
        setVoidedPopDismissed(val: boolean) {
            localStorage.setItem(this.getVoidedPopStorageKey(), val ? '1' : '0')
        },
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { style: {"width":"100%"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_tabs, {
            class: "demo-tabs",
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
            onTabClick: _ctx.handleTabClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "全部",
                name: "alldata"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "待签署",
                name: "0"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "已签署",
                name: "1"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "已撤销",
                name: "2"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "已拒签",
                name: "3"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "到期未签",
                name: "4"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "已解除",
                name: "5"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.payDateSolt,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payDateSolt) = $event)),
                type: "daterange",
                class: "date-solt",
                "unlink-panels": "",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                onChange: _ctx.handleCurrentChange,
                "value-format": "YYYY-MM-DD",
                shortcuts: _unref(shortcuts)
              }, null, 8, ["modelValue", "onChange", "shortcuts"]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "请输入派遣单位/人员名称",
                class: "input search-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event)),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.searchText]
              ]),
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, "搜索"),
              _createElementVNode("button", {
                class: "btn-white",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
              }, "重置"),
              (_ctx.activeTab === 'alldata')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-lightblue setbtn flex-center",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onExport && _ctx.onExport(...args)))
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "导出数据", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Upload)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === '0')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-lightorange",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onBatchCancel && _ctx.onBatchCancel(...args)))
                  }, "批量撤销"))
                : _createCommentVNode("", true),
              (_ctx.activeTab === '1')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn-lightblue",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBatchDownload && _ctx.onBatchDownload(...args)))
                  }, "下载合同"))
                : _createCommentVNode("", true),
              (_ctx.activeTab === '3' || _ctx.activeTab === '4')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "btn-lightred",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onBatchDelete && _ctx.onBatchDelete(...args)))
                  }, "批量删除"))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.showVoidedOutTip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_WarningFilled, {
                  color: "#FFA814",
                  size: "24"
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.showPeople) + "等" + _toDisplayString(_ctx.pageInfo.total) + "人拒绝了您的解除合同的申请，当前合同将变回\"已签署\"状态。 ", 1)
          ]),
          _createElementVNode("div", {
            class: "voided-tip-out-right",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showVoidedPopupFn && _ctx.showVoidedPopupFn(...args)))
          }, "去处理")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "selection" }),
            _createVNode(_component_el_table_column, {
              prop: "serveCompanyName",
              label: "派遣单位名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userName",
              label: "签署人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idCardNo",
              label: "身份证"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flowName",
              label: "模版名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "labourCost",
              label: "工价"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(" ￥" + _toDisplayString(scope.row.labourCost), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "flowStatus",
              label: "合同状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.getStatusClass(scope.row.flowStatusType), "status-tag"])
                }, _toDisplayString(scope.row.flowStatus), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createOn",
              label: "发起时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createUserName",
              label: "发起人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "deadline",
              label: "截止签署时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flowMessage",
              label: "失效原因"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: scope.row.flowMessage,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.truncateFlowMessage(scope.row.flowMessage)), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "220"
            }, {
              default: _withCtx((scope) => [
                ((['1', 'alldata'].includes(_ctx.activeTab)) && (scope.row.flowStatusType === 'ALL') && scope.row.isDelete !== 1 && scope.row.flowId)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "fc-red mg-r-10",
                      onClick: ($event: any) => (_ctx.onShowVoidedPopup(scope.row.id, false))
                    }, " 协商解除 ", 8, _hoisted_10))
                  : _createCommentVNode("", true),
                ((scope.row.flowStatusType === 'RELEASED') && scope.row.dischargeFlowId)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "link mg-r-10",
                      onClick: ($event: any) => (_ctx.goDetail(scope.row.dischargeFlowId))
                    }, " 查看协议 ", 8, _hoisted_11))
                  : _createCommentVNode("", true),
                (scope.row.flowId)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "link mg-r-10",
                      onClick: ($event: any) => (_ctx.goDetail(scope.row.flowId))
                    }, " 查看详情 ", 8, _hoisted_12))
                  : _createCommentVNode("", true),
                ((['ALL', 'RELEASEING', 'RELEASED'].includes(scope.row.flowStatusType)) && scope.row.isDelete !== 1 && scope.row.flowId)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: "link mg-r-10",
                      onClick: ($event: any) => (_ctx.onExporthtalong(scope.row.id))
                    }, " 下载合同 ", 8, _hoisted_13))
                  : _createCommentVNode("", true),
                ((scope.row.flowStatusType === 'INIT' || scope.row.flowStatusType === 'PART') && scope.row.isDelete !== 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 4,
                      class: "fc-orange mg-r-10",
                      onClick: ($event: any) => (_ctx.onCancelContract(scope.row))
                    }, " 撤销合同 ", 8, _hoisted_14))
                  : _createCommentVNode("", true),
                ((scope.row.flowStatusType === 'REJECT' || scope.row.flowStatusType === 'DEADLINE') && scope.row.isDelete !== 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 5,
                      class: "fc-red mg-r-10",
                      onClick: ($event: any) => (_ctx.onDeleteContract(scope.row))
                    }, " 删除合同 ", 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    (_ctx.showVoidedPop)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 1,
          "data-title": "合同解除失败",
          width: "800px",
          onClose: _ctx.onCloseVoidedFailedPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoFilled, {
                      color: "#409EFF",
                      size: "24"
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.showPeople) + "等" + _toDisplayString(_ctx.pageInfo.total) + "人拒绝了您的解除合同的申请，当前合同将变回\"已签署\"状态。 ", 1)
              ]),
              _createVNode(tableComponent, {
                class: "mg-t-10 popup-tables",
                "table-data": _ctx.popupTableData,
                "table-head": _ctx.tableHead,
                "row-key": "id",
                onSelectionChange: _ctx.handlePopupSelectionChange,
                "page-info": _ctx.pageInfo,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["table-data", "table-head", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "btn mini-btn white-btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onShowVoidedPopup(null, true)))
                }, "再次申请解除"),
                _createElementVNode("button", {
                  class: "btn mini-btn long-btn",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleUpdatePop && _ctx.handleUpdatePop(...args)))
                }, "确认恢复“已签署”")
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showVoidedReasonPop)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 2,
          "data-title": "协商解除",
          width: "500px",
          onClose: _ctx.onCloseVoidedPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoFilled, {
                      color: "#409EFF",
                      size: "24"
                    })
                  ]),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "voided-tip-text" }, "解除合同需要与签署方签署解除协议， 对方确认解除后，当前合同将作废处理。", -1))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "voided-content-title" }, "解除原因：", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    placeholder: "请输入作废原因，以便员工同意您的协商解除。",
                    rows: "3",
                    class: "textarea",
                    modelValue: _ctx.flowMessage,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.flowMessage) = $event)),
                    maxlength: "100"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.flowMessage.length) + "/100", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "btn mini-btn whitebtn",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onCloseVoidedPopup && _ctx.onCloseVoidedPopup(...args)))
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "btn mini-btn",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onSendVoidedContractApply && _ctx.onSendVoidedContractApply(...args)))
                }, "发送申请")
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showReasonPop)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 3,
          "data-title": "撤销原因",
          onClose: _ctx.onCloseCancelPopup,
          width: "600px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_el_input, {
                    type: "text",
                    placeholder: "请输入撤销理由，最多16个字符",
                    class: "textarea",
                    modelValue: _ctx.reason,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.reason) = $event)),
                    maxlength: "16"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.reason.length) + "/16", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn mini-btn whitebtn",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onCloseCancelPopup && _ctx.onCloseCancelPopup(...args)))
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "btn mini-btn",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onConfirmCancel && _ctx.onConfirmCancel(...args)))
                }, " 确定 ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showFailPop)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 4,
          "data-title": "撤销失败",
          onClose: _ctx.onCloseCancelPopup,
          width: "600px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _cache[26] || (_cache[26] = _createElementVNode("div", null, [
                _createElementVNode("div", null, "当前合同已被职工打开，请前往「电子合同」程序撤销")
              ], -1)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  class: "btn mini-btn whitebtn",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onCloseCancelPopup && _ctx.onCloseCancelPopup(...args)))
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "btn mini-btn long-btn",
                  onClick: _cache[22] || (_cache[22] = () => { _ctx.goDetail(_ctx.currentFlowId); _ctx.onCloseCancelPopup(); })
                }, " 打开电子合同 ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})